<script>
    import QuoteSlider from './Part/QuoteSlider.vue';

    export default {
        components: {
            QuoteSlider
        },
        data() {
            return {
                data: {},
                agreeTerms: false,
                togglePassword: false,
                toggleConfirmPassword: false,
            }
        },
        mounted() {
            var vm = this;

            vm.create();
        },
        methods: {
            create() {
                var vm = this;

                vm.createEmptyData();
            },
            createEmptyData() {
                var vm = this;

                var data = {
                    name: null,
                    email: null,
                    password: null,
                    confirm_password: null,
                };

                vm.data = Object.assign({}, data);
            },
            _createPostData(data) {
                return data;
            },
            async submit() {
                var vm = this;

                try {
                    vm.$loading.on('signup_submit');

                    var data = vm._createPostData(vm.data);

                    var resp = await vm.$api.Auth.signup(data);
                    vm.$api.setApiToken(resp.data.data.access_token);

                    vm.$router.push({ name: 'verify-email' });

                    // vm.$flash.success(resp.data.message);
                } catch (error) {
                    vm.$flash.error(error.response.data.message);
                }

                vm.$loading.off('signup_submit');
            },
        },
    };
</script>

<template>
    <div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
        <div class="bg-overlay"></div>
        <div class="auth-page-content overflow-hidden pt-lg-5">
            <BContainer>
                <BRow>
                    <BCol lg="12">
                        <BCard no-body class="overflow-hidden m-0">
                            <BRow class="justify-content-center g-0">
                                <BCol lg="6">
                                    <QuoteSlider />
                                </BCol>

                                <BCol lg="6">
                                    <div class="p-lg-5 p-4">
                                        <div>
                                            <h5 class="text-primary">{{ $t('signup.label.title') }}</h5>
                                            <p class="text-muted">{{ $t('signup.label.sub_title') }}</p>
                                        </div>

                                        <div class="mt-4">
                                            <b-form @submit="submit()">
                                                <div class="mb-3">
                                                    <label for="name" class="form-label">{{ $t('signup.label.name') }}
                                                        <span class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" id="name"
                                                        :placeholder="$t('signup.placeholder.name')"
                                                        v-model="data.name">
                                                </div>
                                                <div class="mb-3">
                                                    <label for="email" class="form-label">{{ $t('signup.label.email') }}
                                                        <span class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" id="email"
                                                        :placeholder="$t('signup.placeholder.email')"
                                                        v-model="data.email">
                                                </div>
                                                <div class="mb-3">
                                                    <label class="form-label" for="password-input">{{
                                                        $t("signup.label.password") }} <span
                                                            class="text-danger">*</span></label>
                                                    <div class="position-relative auth-pass-inputgroup mb-3">
                                                        <input :type="togglePassword ? 'text' : 'password'"
                                                            class="form-control pe-5"
                                                            :placeholder="$t('signup.placeholder.password')"
                                                            id="password-input" v-model="data.password">
                                                        <BButton variant="link"
                                                            class="position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                            type="button" id="password-addon"
                                                            @click="togglePassword = !togglePassword"><i
                                                                class="ri-eye-fill align-middle"></i></BButton>
                                                    </div>
                                                </div>
                                                <div class="mb-3">
                                                    <label class="form-label" for="password-input">{{
                                                        $t("signup.label.confirm_password") }} <span
                                                            class="text-danger">*</span></label>
                                                    <div class="position-relative auth-pass-inputgroup mb-3">
                                                        <input :type="toggleConfirmPassword ? 'text' : 'password'"
                                                            class="form-control pe-5"
                                                            :placeholder="$t('signup.placeholder.confirm_password')"
                                                            id="password-input" v-model="data.confirm_password">
                                                        <BButton variant="link"
                                                            class="position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                            type="button" id="password-addon"
                                                            @click="toggleConfirmPassword = !toggleConfirmPassword"><i
                                                                class="ri-eye-fill align-middle"></i></BButton>
                                                    </div>
                                                </div>
                                                <div class="mb-4 d-flex align-items-start">
                                                    <div class="form-check form-check-success mb-3">
                                                        <input class="form-check-input me-2 mt-1 custom-checkbox" type="checkbox"
                                                            id="agreeTerms"
                                                            v-model="agreeTerms">
                                                    </div>
                                                    <label class="mb-0 fs-12 text-muted fst-italic">
                                                        Dengan mendaftar, saya menyatakan telah membaca, memahami, dan
                                                        menyetujui
                                                        <a href="https://cafeman.id/terms-and-conditions"
                                                            target="_blank"
                                                            class="text-primary text-decoration-underline fst-normal fw-medium">
                                                            Syarat dan Ketentuan Layanan
                                                        </a>
                                                        serta
                                                        <a href="https://cafeman.id/privacy-policy"
                                                            target="_blank"
                                                            class="text-primary text-decoration-underline fst-normal fw-medium">
                                                            Kebijakan Privasi
                                                        </a>
                                                        yang berlaku di Cafeman.
                                                    </label>
                                                </div>
                                                <div class="mt-4">
                                                    <BButton variant="primary" class="w-100" type="submit"
                                                        :disabled="$loading.get('signup_submit') || !agreeTerms">
                                                        <loading :loading="$loading.get('signup_submit')">
                                                            {{ $t('signup.btn.signup') }}
                                                        </loading>
                                                    </BButton>
                                                </div>
                                            </b-form>
                                        </div>

                                        <div class="mt-5 text-center">
                                            <p class="mb-0">{{ $t('signup.label.signin') }}<router-link
                                                    :to="{ name: 'login' }"
                                                    class="fw-semibold text-primary text-decoration-underline">&nbsp;{{
                                                        $t('signup.btn.signin') }}
                                                </router-link>
                                            </p>
                                        </div>
                                    </div>
                                </BCol>
                            </BRow>
                        </BCard>
                    </BCol>

                </BRow>
            </BContainer>
        </div>

        <footer class="footer">
            <BContainer>
                <BRow>
                    <BCol lg="12">
                        <div class="text-center">
                            <p class="mb-0">&copy; 2026 Cafeman. Seluruh Hak Cipta Dilindungi.</p>
                        </div>
                    </BCol>
                </BRow>
            </BContainer>
        </footer>
    </div>
</template>

<style>
    .custom-checkbox {
        width: 1.3rem;
        height: 1.3rem;
        border: 2px solid #6c757d;
        cursor: pointer;
    }

    .custom-checkbox:checked {
        border-color: var(--bs-success);
    }
</style>